var React = require('react');

function GraduationCap32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M29 21.941c-1.102 0-2-.897-2-1.997 0-.736.405-1.373 1-1.72v-7.543l-4.019 2.293c.003.033.019.062.019.095v9.87c0 .038-.018.071-.022.109a1.038 1.038 0 0 1-.04.198 1.056 1.056 0 0 1-.182.327.982.982 0 0 1-.149.139c-.029.023-.047.055-.08.075-.141.088-3.524 2.147-8.527 2.147-5.003 0-8.386-2.059-8.527-2.147-.033-.02-.051-.052-.08-.075a.94.94 0 0 1-.371-.664c-.004-.037-.022-.07-.022-.109v-9.87c0-.033.016-.062.019-.095L.504 9.827a.995.995 0 0 1 0-1.733l14-7.988c.306-.175.685-.175.992 0l14 7.988a.996.996 0 0 1 .504.867c0 .017-.012.031-.013.049.001.023.013.043.013.066v9.148c.595.347 1 .984 1 1.72 0 1.1-.897 1.997-2 1.997zm-7 .403v-8.24l-6.504 3.711a.996.996 0 0 1-.992 0L8 14.104v8.237c1.004.502 3.578 1.597 7 1.597 3.442 0 6.001-1.092 7-1.594zM15 2.123L3.016 8.961 15 15.798l11.984-6.837L15 2.123z","key":1})]);
}

GraduationCap32px.displayName = "GraduationCap32px";

GraduationCap32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31 25.94"};

module.exports = GraduationCap32px;

GraduationCap32px.default = GraduationCap32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/graduation-cap-32px.svg
// module id = 1098
// module chunks = 0